export interface RiskAnalysisRowData {
  id: string;
  risk: string;
  CCPorGAG: string;
  general: string;
  description: string;
  prevent: string;
}

export interface RiskAnalysisTableData {
  title: string;
  data: Record<string, RiskAnalysisRowData>;
}

export const riskAnalysisTableData: RiskAnalysisTableData[] = [
  {
    title: "Varemodtagelse",
    data: {
      riskAnalysis1: {
        id: "riskAnalysis1",
        risk: "Mikrobiologisk",
        CCPorGAG: "CCP",
        general: "Generelt",
        description:
          "For at sikre fødevaresikkerheden ved varemodtagelse skal letfordærvelige fødevarer opfylde de rette temperaturkrav. Fersk fisk og fiskefars skal være maks. +2 °C, kølevarer maks. +5 °C, og frostvarer skal være -18 °C eller koldere. Det er vigtigt altid at kontrollere emballagen for specifikke krav fra producenten. Temperaturen bør kontrolleres ved modtagelse for at sikre, at varerne lever op til kravene og kan opbevares korrekt efterfølgende.",
        prevent:
          "Fersk fisk og fiskefars skal opbevares ved maks. +2 °C, kølevarer generelt ved maks. +5 °C (tjek producentens mærkning), og frostvarer ved -18 °C eller koldere, så længe de forbliver frosne. Leverandøren skal overholde holdbarheds- og temperaturkrav under transport. Ved modtagelse kontrolleres temperaturen på alle kølekrævende varer.",
      },
      riskAnalysis2: {
        id: "riskAnalysis2",
        risk: "Mikrobiologisk",
        CCPorGAG: "GAG",
        general: "Generelt",
        description:
          "Ved modtagelse af varer skal personalet kontrollere, at de er korrekt mærket, i god stand, inden for holdbarhedsdatoen og uden skader. Opdages der fejl, afvises varen eller håndteres efter virksomhedens procedurer.",
        prevent:
          "Det er leverandørens ansvar at sikre, at de leverede varer er egnet til menneskeføde. Modtagervirksomheden har ansvar for at kontrollere, at leverandøren er autoriseret eller registreret hos Fødevarestyrelsen",
      },
      riskAnalysis3: {
        id: "riskAnalysis3",
        risk: "Mikrobiologisk",
        CCPorGAG: "GAG",
        general: "Urter",
        description:
          "Vilde urter kan være forurenet med mikroorganismer fra deres naturlige voksesteder, hvilket kan medføre hygiejniske problemer og risiko for sygdom.",
        prevent:
          "Det er leverandørens ansvar at sikre, at de leverede varer er egnet til menneskeføde. Modtagervirksomheden har ansvar for at kontrollere, at leverandøren er autoriseret eller registreret hos Fødevarestyrelsen",
      },
      riskAnalysis4: {
        id: "riskAnalysis4",
        risk: "Mikrobiologisk",
        CCPorGAG: "GAG",
        general: "Emballage",
        description:
          "Hvis emballagen er brudt eller slået itu, kan der være risiko for, at varen er blevet forurenet under transporten. Derudover kan materiale som metal, hård plastik, træ eller glas fra ødelagt emballage ende i det færdige produkt, hvilket kan være farligt for kunderne. Derfor sikres det, at emballagen på de varer, virksomheden modtager eller anvender, ikke er beskadiget.",
        prevent:
          "Krav til leverandør samt visuel kontrol ved modtagelse af fødevarer.",
      },
      riskAnalysis5: {
        id: "riskAnalysis5",
        risk: "Mikrobiologisk",
        CCPorGAG: "CCP",
        general: "Mejeri og ost",
        description:
          "Letfordærvelige mejeriprodukter og ost skal opbevares og transporteres ved de gældende temperaturkrav for at forhindre vækst af sygdomsfremkaldende mikroorganismer. Manglende hygiejne under transport kan medføre risiko for kontaminering af varerne. Det er derfor vigtigt at sikre både korrekt temperatur og hygiejne i hele transport- og opbevaringskæden.",
        prevent:
          "Letfordærvelige fødevarer skal transporteres ved korrekte temperaturer i ubrudt kølekæde. Leverandøren sikrer dette, og virksomheden udfører stikprøvekontrol ved modtagelse og dokumenterer i egenkontrolprogrammet. Ved selvhentning bruges kølebil, termokasser eller køleelementer, og transportmidlet skal være hygiejnisk.",
      },
      riskAnalysis6: {
        id: "riskAnalysis6",
        risk: "Mikrobiologisk",
        CCPorGAG: "GAG",
        general: "Gær",
        description:
          "Hvis gær ikke opbevares køligt ved korrekt temperatur, mister gæren sine teknologiske egenskaber og brødet kvalitet forringes. Der vuderes ikke nogle risici for mennesker sundhed hvis der er anvendt gær med forringet bageværdi. Hvis transporten ikke foregår hygiejnisk, kan der være risiko for at varerne forurenes",
        prevent:
          "Gær skal modtages og opbevares køligt i overensstemmelse med leverandørens anvisninger på mærkningen. Hvis der observeres synlige lodne pletter på gæren, kan det indikere skimmelvækst, og gæren skal straks kasseres.",
      },
      riskAnalysis7: {
        id: "riskAnalysis7",
        risk: "Mikrobiologisk",
        CCPorGAG: "GAG",
        general: "Fisk",
        description:
          "Fisk som tun, makrel, hornfisk, escolar og oliefisk kan danne histamin ved forkert opbevaring. Opbevar rå fisk ved maks. +2 °C, og minimer håndtering ved stuetemperatur.",
        prevent:
          "Fisk som tun og makrel smages løbende for histamin. Rå fisk opbevares ved maks. +2 °C, og håndtering ved stuetemperatur minimeres. Escolar og oliefisk tilberedes korrekt for at smelte voksarter ud, og kogevand genbruges ikke. Fødevarekontaktmaterialer sikres egnede via leverandørerklæringer.",
      },
      riskAnalysis8: {
        id: "riskAnalysis8",
        risk: "Mikrobiologisk",
        CCPorGAG: "GAG",
        general: "Ikke kølepligtige varer",
        description:
          "Manglende mærkning kan føre til, at varer opbevares for længe og bliver uegnede. Defekte dåser og ødelagt emballage kan medføre bakterievækst og forurening. Frugt og grønt med råd eller mug skal kasseres for at sikre fødevaresikkerheden",
        prevent:
          "Fødevarer skal være korrekt mærket ved modtagelse. Defekte dåser, ødelagt emballage og frugt eller grønt med mug eller råd kasseres straks for at sikre fødevaresikkerheden.",
      },
      riskAnalysis9: {
        id: "riskAnalysis9",
        risk: "Mikrobiologisk",
        CCPorGAG: "GAG",
        general: "Mel og kerne, mm",
        description:
          "Mel og kerner kan blive angrebet af larver, skimmel eller mug, hvilket gør dem uegnede til menneskeføde. For at sikre fødevaresikkerheden skal transporten foregå hygiejnisk for at undgå risiko for forurening af varerne.",
        prevent:
          "Ved hver produktion kontrolleres mel og kerner for skadedyr. Opbevar altid mel og kerner tørt i lukkede eller tætsluttende emballager og i lokaler, der er sikret mod skadedyr.",
      },
      riskAnalysis10: {
        id: "riskAnalysis10",
        risk: "Mikrobiologisk",
        CCPorGAG: "GAG",
        general: "Varmebehandlet kød og pålæg",
        description:
          "Hvis letfordærvelige fødevarer ikke opbevares ved de korrekte temperaturer, kan væksten af sygdomsfremkaldende mikroorganismer øges og udgøre en sundhedsrisiko. Manglende hygiejne under transport kan desuden medføre forurening af varerne, hvilket kan gøre dem uegnede til konsum.",
        prevent:
          "Leverandører skal sikre korrekt temperatur under transport. Ved modtagelse udføres stikprøvekontrol, og procedurer dokumenteres i egenkontrolprogrammet.",
      },
      riskAnalysis11: {
        id: "riskAnalysis11",
        risk: "Mikrobiologisk",
        CCPorGAG: "GAG",
        general: "Fisk parasitter",
        description:
          "Fersk fisk kan indeholde parasitter, som udgør en sundhedsrisiko for mennesker, hvis fisken ikke behandles korrekt.",
        prevent:
          "Ved modtagelse og efterfølgende bearbejdning af fisk udføres løbende visuel kontrol for synlige parasitter. Hvis der konstateres parasitter, fjernes de omhyggeligt ved udskæring, eller hele fisken kasseres, hvis parasitterne ikke kan fjernes tilfredsstillende.",
      },
      riskAnalysis12: {
        id: "riskAnalysis12",
        risk: "Kemisk",
        CCPorGAG: "GAG",
        general: "Generelt",
        description:
          "Fødevarer leveret til butikker og restauranter skal komme fra Fødevarestyrelsen-registrerede virksomheder, der har gennemført en kemisk risikovurdering af råvarerne.",
        prevent:
          "Alle leverandører skal være registreret/autoriseret hos Fødevarestyrelsen. Ved modtagelse af uemballerede fødevarer, grønt og frugt sikres det, at transporten har været korrekt, så fødevarerne ikke er blevet forurenet.",
      },
      riskAnalysis13: {
        id: "riskAnalysis13",
        risk: "Kemisk",
        CCPorGAG: "GAG",
        general: "Escolar",
        description:
          "Fiskene Escolar og oliefisk/smørmakrel indeholder naturligt voksarter, som kan forårsage diarré, hvis de ikke tilberedes korrekt. Dette skyldes de ufordøjelige voks-estre, og effekten ligner virkningen af amerikansk olie.",
        prevent:
          "Ved tilberedning af escolar og oliefisk/smørmakrel skal fisken steges eller koges grundigt, så olieindholdet og voksarterne smelter ud. Kogevand og stegefedt må ikke bruges til sovs eller anden madlavning. Ved salg af rå escolar og oliefisk/smørmakrel skal forbrugeren informeres om dette.",
      },
      riskAnalysis14: {
        id: "riskAnalysis14",
        risk: "Kemisk",
        CCPorGAG: "GAG",
        general: "Fødevarekontaktmaterialer",
        description:
          "Hvis fødevarekontaktmaterialer som opbevaring, emballage, redskaber og udstyr ikke er egnede, kan der være risiko for, at kemiske stoffer overføres fra materialet til fødevarerne.",
        prevent:
          "Det sikres gennem specifikationer, leverandørerklæringer m.m., at indkøbte fødevarekontaktmaterialer og udstyr er egnede til formålet.",
      },
      riskAnalysis15: {
        id: "riskAnalysis15",
        risk: "Kemisk",
        CCPorGAG: "CCP",
        general: "Fisk",
        description:
          "Ved modtagelse og opbevaring af rå fersk fisk skal temperaturen altid være 2 °C eller koldere. For høje temperaturer kan føre til dannelse af histamin, som kan forårsage alvorlige forgiftninger. Temperaturen kan opretholdes ved at opbevare fisken på is.",
        prevent: "Temperaturkontrol/dokumentation iht egenkontroldokument",
      },
      riskAnalysis16: {
        id: "riskAnalysis16",
        risk: "Fysisk",
        CCPorGAG: "GAG",
        general: "Emballage",
        description:
          "Hvis emballagen er beskadiget eller brudt, kan der være risiko for, at varen er blevet forurenet under transporten.",
        prevent:
          "Ved modtagelse udføres en visuel kontrol for at sikre, at emballagen er intakt, fødevarerne er i god stand, og der ikke er tegn på forurening eller skader.",
      },
    },
  },
  {
    title: "Adskillelse - Opbevaring",
    data: {
      riskAnalysis17: {
        id: "riskAnalysis17",
        risk: "Mikrobiologisk",
        CCPorGAG: "GAG",
        general: "Opbevaring",
        description:
          "Fødevarer må aldrig opbevares direkte på gulvet eller i lokaler med direkte adgang til toilettet, da det kan føre til forurening. Der skal sikres adskillelse ved opbevaring for at undgå krydskontaminering, hvor bakterier fra ferske fødevarer kan overføres til færdigbehandlede produkter",
        prevent:
          "I det tilpassede egenkontrolprogram er der fastlagte procedurer for at sikre adskilt opbevaring af ferske/urensede og tilberedte fødevarer. Derudover må fødevarer aldrig opbevares direkte på gulvet.",
      },
      riskAnalysis18: {
        id: "riskAnalysis18",
        risk: "Kemisk",
        CCPorGAG: "GAG",
        general: "Emballage",
        description:
          "Uemballerede fødevarer må ikke opbevares sammen med rengørings- eller desinfektionsmidler, da det kan medføre risiko for forurening af fødevarerne.",
        prevent:
          "I det tilpassede egenkontrolprogram er der fastlagt procedurer for adskilt opbevaring, herunder opbevaring af rengøringsmidler og andre relevante materialer.",
      },
      riskAnalysis19: {
        id: "riskAnalysis19",
        risk: "Kemisk",
        CCPorGAG: "GAG",
        general: "Fødevarekontaktmaterialer",
        description:
          "Hvis fødevarekontaktmaterialer som emballage, plastfilm, redskaber, inventar eller produktionsudstyr ikke er egnet til formålet, kan der opstå risiko for, at kemiske stoffer overføres til fødevarerne. For at minimere denne risiko skal der kun bruges materialer, der er specifikt beregnet til fødevarekontakt.",
        prevent:
          "Personalet er instrueret i kun at bruge emballager til det, de er egnet og beregnet til, og at det er vigtigt at tage hensyn til, om emballagen skal bruges til fx varme, fede eller sure produkter.",
      },
      riskAnalysis20: {
        id: "riskAnalysis20",
        risk: "Kemisk",
        CCPorGAG: "GAG",
        general: "Allergener",
        description:
          "Allergen-følsomme personer kan få alvorlige reaktioner, hvis de indtager produkter, der indeholder allergene ingredienser.",
        prevent:
          "Det sikres, at allergene fødevarer og ingredienser i åbne emballager opbevares godt og adskilt, for at minimere risikoen for krydskontaminering med allergener.",
      },
      riskAnalysis21: {
        id: "riskAnalysis21",
        risk: "Fysisk",
        CCPorGAG: "GAG",
        general: "Lokaler",
        description:
          "Hvis opbevaring sker i lokaler, skabe eller rum med mangelfuld vedligeholdelse eller som ikke er egnede til fødevarer, kan der opstå risiko for forurening fra fx neddrys fra lofter.Desuden kan materiale fra ødelagt udstyr eller inventar ende i de færdige fødevarer, hvilket kan være farligt for kunderne. Derfor sikres det, at virksomhedens indretning er hensigtsmæssig, og at inventar og udstyr løbende kontrolleres og vedligeholdes.",
        prevent:
          "Det sikres, at varer opbevares i egnede lokaler, rum eller skabe, og at de er beskyttet mod ydre forurening under opbevaring.",
      },
    },
  },
  {
    title: "Temperatur på køl og frost - Opbevaring",
    data: {
      riskAnalysis22: {
        id: "riskAnalysis22",
        risk: "Mikrobiologisk",
        CCPorGAG: "CCP",
        general: "Køleopbevaring",
        description:
          "Når kølevarer modtages eller opbevares, sikrer virksomheden, at produkterne overholder relevante temperaturkrav. Temperaturen i køleenheder skal altid være 5 °C eller koldere, medmindre en lavere temperatur er angivet på fødevarens mærkning eller fastsat i fødevarelovgivningen. Dette er nødvendigt for at forhindre bakterievækst og bevare fødevarernes kvalitet og sikkerhed",
        prevent:
          "Temperaturkontrol og dokumentation udføres i henhold til virksomhedens egenkontroldokument, hvor temperaturer regelmæssigt overvåges og registreres for at sikre overholdelse af gældende krav til fødevaresikkerhed.",
      },
      riskAnalysis23: {
        id: "riskAnalysis23",
        risk: "Mikrobiologisk",
        CCPorGAG: "GAG/CCP",
        general: "Gær",
        description:
          "Hvis gær ikke opbevares korrekt ved kølig temperatur, forringes dens bageegenskaber og brødets kvalitet. Der er ingen sundhedsrisiko ved brug af gær med nedsat bageværdi.",
        prevent:
          "Opbevar gær køligt i henhold til leverandørens anvisninger på mærkningen. Hvis der ses lodne pletter på gæren, kan det indikere skimmelvækst, og gæren skal straks kasseres.",
      },
      riskAnalysis24: {
        id: "riskAnalysis24",
        risk: "Mikrobiologisk",
        CCPorGAG: "CCP",
        general: "Frost opbevaring",
        description:
          "Når frostvarer modtages eller opbevares, sikrer virksomheden, at produkterne er frosne og overholder relevante temperaturkrav. Temperaturen i fryseenheder skal altid være -18 °C eller koldere, medmindre en lavere temperatur er angivet på fødevarens mærkning eller fastsat i fødevarelovgivningen. Dette er nødvendigt for at forhindre bakterievækstog bevare fødevarernes kvalitet og sikkerhed.",
        prevent:
          "Temperaturkontrol og dokumentation udføres i henhold til virksomhedens egenkontroldokument, hvor temperaturer regelmæssigt overvåges og registreres for at sikre overholdelse af gældende krav til fødevaresikkerhed.",
      },
      riskAnalysis25: {
        id: "riskAnalysis25",
        risk: "Mikrobiologisk",
        CCPorGAG: "CCP",
        general: "Fersk fisk",
        description:
          "Opbevaring af frisk fisk kræver, at temperaturen altid holdes på 2 °C eller koldere for at forhindre bakterievækst og dannelse af histamin, som kan forårsage alvorlige forgiftninger. Temperaturen kan sikres ved opbevaring på is og ved at følge de angivne temperaturkrav på fødevarens mærkning eller i fødevarelovgivningen.",
        prevent:
          "Temperaturkontrol og dokumentation udføres i henhold til virksomhedens egenkontroldokument, hvor temperaturer regelmæssigt overvåges og registreres for at sikre overholdelse af gældende krav til fødevaresikkerhed.",
      },
      riskAnalysis26: {
        id: "riskAnalysis26",
        risk: "Mikrobiologisk",
        CCPorGAG: "-",
        general: "-",
        description: "-",
        prevent: "-",
      },
      riskAnalysis27: {
        id: "riskAnalysis27",
        risk: "Mikrobiologisk",
        CCPorGAG: "GAG",
        general: "Kapacitet",
        description:
          "Ved opbevaring af køle- og frostkrævende fødevarer skal der være fokus på at undgå overfyldning af køle- og fryseskabe, da det kan reducere luftcirkulationen og nedsætte deres køle- og fryseevne. Dette kontrolleres for at sikre korrekt opbevaringstemperatur.",
        prevent:
          "Temperaturkontrol og dokumentation udføres i henhold til virksomhedens egenkontroldokument, hvor temperaturer regelmæssigt overvåges og registreres for at sikre overholdelse af gældende krav til fødevaresikkerhed.",
      },
      riskAnalysis28: {
        id: "riskAnalysis28",
        risk: "Kemisk",
        CCPorGAG: "GAG",
        general: "Emballage",
        description:
          "Hvis fødevarekontaktmaterialer, som bruges til opbevaring, emballering, inventar eller redskaber, ikke er egnet til formålet, kan der opstå risiko for, at kemiske stoffer overføres til fødevarerne.\tDet sikres gennem specifikationer, leverandørerklæringer og lignende, at indkøbte fødevarekontaktmaterialer og udstyr er egnet til formålet. Personalet er instrueret i kun at bruge emballager til det, de er beregnet til, og i at tage hensyn til, om emballagen skal anvendes til fx varme, fede eller sure produkter.",
        prevent:
          "Det sikres gennem specifikationer, leverandørerklæringer og lignende, at indkøbte fødevarekontaktmaterialer og udstyr er egnet til formålet.Personalet er instrueret i kun at bruge emballager til det, de er beregnet til, og i at tage hensyn til, om emballagen skal anvendes til fx varme, fede eller sure produkter.",
      },
      riskAnalysis29: {
        id: "riskAnalysis29",
        risk: "Fysisk",
        CCPorGAG: "GAG",
        general: "Lokaler",
        description:
          "Hvis fødevarekontaktmaterialer, som bruges til opbevaring, emballering, inventar eller redskaber, ikke er egnet til formålet, kan der opstå risiko for, at kemiske stoffer overføres til fødevarerne.",
        prevent:
          "Det sikres gennem specifikationer, leverandørerklæringer og lignende, at indkøbte fødevarekontaktmaterialer og udstyr er egnet til formålet.Personalet er instrueret i kun at bruge emballager til det, de er beregnet til, og i at tage hensyn til, om emballagen skal anvendes til fx varme, fede eller sure produkter.",
      },
      riskAnalysis30: {
        id: "riskAnalysis30",
        risk: "Fysisk",
        CCPorGAG: "GAG",
        general: "Lokaler",
        description:
          "Hvis opbevaring sker i lokaler, skabe eller rum, der er dårligt vedligeholdte eller ikke er egnede til fødevarer, kan der være risiko for, at fødevarerne bliver forurenet af støv fra lofter og lignende. Varerne opbevares i passende lokaler, rum eller skabe og beskyttes mod ydre forurening under hele opbevaringsperioden.",
        prevent:
          "Varerne opbevares i passende lokaler, rum eller skabe og beskyttes mod ydre forurening under hele opbevaringsperioden.",
      },
    },
  },
  {
    title: "Holdbarhed",
    data: {
      riskAnalysis31: {
        id: "riskAnalysis31",
        risk: "Mikrobiologisk",
        CCPorGAG: "GAG",
        general: "Egenproducerede vare",
        description:
          "Spiseklare fødevarer er produkter, der spises uden yderligere varmebehandling (+75 °C). Hvis holdbarheden på spiseklare fødevarer som pålægsvarer og varmebehandlede kødprodukter overskrides, øges risikoen for vækst af skadelige mikroorganismer, især Listeria, som kan udgøre en alvorlig sundhedsrisiko.",
        prevent:
          "Virksomheden fastsætter holdbarheden på spiseklare fødevarer med vurdering af Listeria-risiko. Listeria kan vokse ved køleskabstemperatur, i vakuum og MAP, men hæmmes ved pH under 4,5, salt over 10 %, tørring og rygning. Holdbarhed under 5 dage anses som sikker, hvis produktion og opbevaring er hygiejnisk. For holdbarhed over 5 dage skal vækstbetingelser vurderes, fx pH, salt, konservering eller røgning. Indfrysning kan forlænge holdbarheden, og optøning skal ske ved maks. 5 °C.",
      },
      riskAnalysis33: {
        id: "riskAnalysis33",
        risk: "Mikrobiologisk",
        CCPorGAG: "GAG",
        general: "Hakketkød",
        description:
          "Hakket kød er følsomt, da bakterier hurtigt kan vokse på den store overflade. Holdbarhed må ikke overskrides, da det kan medføre risiko for sygdomsfremkaldende bakterier. Kød hakket i butikken har en holdbarhed på under 24 timer fra hakningstidspunktet, mens kød i beskyttende atmosfære kan have længere holdbarhed.",
        prevent:
          "Hakket kød med holdbarhed under 24 timer skal anvendes inden for 24 timer efter hakning. Fryseforlængelse er kun tilladt inden for denne periode, og indfrysningsdatoen skal dokumenteres. Kød pakket i beskyttende atmosfære må anvendes inden for den påtrykte holdbarhed, så længe emballagen er intakt og opbevaringskrav (+2 °C/+5 °C) overholdes. Efter emballagebrud skal kødet bruges inden for 24 timer, dog ikke ud over den oprindelige holdbarhed. For detailvirksomheder med engros gælder, at hakket kød altid skal opbevares ved maks. +2 °C",
      },
      riskAnalysis34: {
        id: "riskAnalysis34",
        risk: "Mikrobiologisk",
        CCPorGAG: "GAG",
        general: "Holdbarhed",
        description:
          "Spiseklare fødevarer, som pålæg og varmebehandlede kødprodukter, skal opbevares maks. 5 dage for at minimere risikoen for Listeria, som kan vokse ved køleskabstemperaturer (ned til 0 °C). Listeria trives i vakuum- og MAP-pakninger, ved pH under 4,5 og overlever tørring og rygning, men dræbes ved varmebehandling over +75 °C.",
        prevent:
          "Opbevar gær køligt i henhold til leverandørens anvisninger på mærkningen. Hvis der ses lodne pletter på gæren, kan det indikere skimmelvækst, og gæren skal straks kasseres.",
      },
      riskAnalysis35: {
        id: "riskAnalysis35",
        risk: "Mikrobiologisk",
        CCPorGAG: "GAG",
        general: "Færdigpakkede fødevarer",
        description:
          "Hvis færdigpakkede fødevarer mærket med 'Bedst før' bruges efter udløbsdatoen uden en faglig vurdering af produktet, kan der være risiko for, at uønskede bakterier gør fødevaren uegnet til konsum.",
        prevent:
          "Fødevarer mærket med 'Bedst før' kan bruges efter datoen, hvis de vurderes som egnede til konsum. Produkter kan fryses før og efter udløb, men holdbarheden efter optøning skal være kort. Ved salg af udløbne varer skal butikken have vurderet fødevaren og informere kunderne om udløbet.",
      },
      riskAnalysis36: {
        id: "riskAnalysis36",
        risk: "Mikrobiologisk",
        CCPorGAG: "GAG",
        general: "Generelt",
        description:
          "Hvis letfordærvelige fødevarer ikke opbevares ved de rette temperaturer, kan mikroorganismer vokse og gøre mennesker syge. Generelle temperaturkrav: Fersk fisk og fiskefars: højst +2 °C Kølevarer: højst +5 °C (tjek mærkningen for eventuelle andre krav fra producenten) Frostvarer: -18 °C eller koldere (GAG",
        prevent:
          "Kølefaciliteter må ikke overfyldes, og døre skal åbnes minimalt. Letfordærvelige fødevarer opbevares ved omgivelsestemperatur i kortest tid. Temperaturkrav: fersk fisk og fiskefars max +2 °C, kølevarer max +5 °C (tjek mærkning), og frostvarer skal være -18 °C eller koldere uden mikrobiel risiko.",
      },
      riskAnalysis37: {
        id: "riskAnalysis37",
        risk: "Mikrobiologisk",
        CCPorGAG: "GAG",
        general: "Fødevarerkontaktmaterialer",
        description:
          "Hvis fødevarekontaktmaterialer som opbevaring, emballage og redskaber ikke er egnede, kan kemiske stoffer overføres fra materialet til fødevarerne.",
        prevent:
          "Det sikres gennem specifikationer og leverandørerklæringer, at indkøbte fødevarekontaktmaterialer og udstyr er egnede til formålet. Personalet er instrueret i kun at bruge emballage til det, den er beregnet til, og at det er vigtigt at tage højde for, om emballagen bruges til varme, fede eller sure produkter.",
      },
    },
  },
  {
    title: "Håndtering af varer og produktion",
    data: {
      riskAnalysis38: {
        id: "riskAnalysis38",
        risk: "Mikrobiologisk",
        CCPorGAG: "CCP",
        general: "Varmebehandling og genopvarmning",
        description:
          "Fødevarer, der kræver varmebehandling eller genopvarmning, skal opnå en kernetemperatur på mindst +75 °C for at dræbe sygdomsfremkaldende mikroorganismer som Listeria, Salmonella, Bacillus cereus og Campylobacter. Undtagelser er hele kødstykker som roastbeef og svinekam, der ikke behøver gennemstegning, da bakterier kun findes på overfladen. Fjerkræ skal dog altid opvarmes til mindst +75 °C, mens hele fiskestykker kræver +60 °C i ét minut eller indfrysning i 24 timer ved -20 °C. Ved brug af frosne råvarer følges altid producentens anvisninger.",
        prevent:
          "Der udføres løbende kontrolmålinger på varmebehandlede fødevarer for at sikre, at kravene overholdes. Generelt skal fødevarer opvarmes til mindst +75 °C, fisk til mindst +60 °C, og frosne hindbær skal koges ved 100 °C i 1 minut. Ved sous vide eller langtidsstegning skal virksomheden dokumentere, at den anvendte kombination af tid og temperatur har samme effekt som opvarmning til +75 °C. Dokumentation kan baseres på videnskabeligt materiale",
      },
      riskAnalysis39: {
        id: "riskAnalysis39",
        risk: "Mikrobiologisk",
        CCPorGAG: "CCP",
        general: "Varmholdt",
        description:
          "Letfordærvelige fødevarer må ikke opbevares mellem +5 °C og +65 °C, da det øger risikoen for vækst af skadelige mikroorganismer. Varmebehandlede fødevarer skal varmholdes ved mindst 65 °C i alle dele af produktet. Hvis temperaturen falder under 65 °C, skal fødevaren inden for 3 timer enten serveres, genopvarmes eller kasseres for at sikre fødevaresikkerheden.",
        prevent:
          "Der udføres løbende visuel kontrol af faste termometre og periodevise temperaturmålinger for at sikre korrekt varmholdelse. Maden skal opvarmes til over +75 °C umiddelbart inden den stilles til varmholdelse. Varmemediet skal tændes i god tid, så det er varmt nok til at holde maden på mindst +65 °C i hele den varmholdte ret.",
      },
      riskAnalysis40: {
        id: "riskAnalysis40",
        risk: "Mikrobiologisk",
        CCPorGAG: "CCP",
        general: "Langtidstilberedning under +75 °C",
        description:
          "Der er risiko for vækst af sporer og utilstrækkeligt drab af sygdomsfremkaldende bakterier, såsom Listeria monocytogenes, Salmonella, Bacillus cereus og Clostridium perfringens, hvis den korrekte kombination af tid og temperatur ikke anvendes under opvarmning. Ved brug af LTLT-metoder som sous vide og langtidstilberedning er det afgørende at styre tid og temperatur nøje for at sikre både fødevaresikkerhed, kvalitet og holdbarhed",
        prevent:
          "Der skal udføres løbende visuel kontrol for at sikre, at nedkølingsprocedurerne følges. Det betyder, at temperaturen skal falde fra +65 °C til +10 °C på højst 4 timer, og fødevaren skal opbevares ved højst +5 °C derefter.",
      },
      riskAnalysis41: {
        id: "riskAnalysis41",
        risk: "Mikrobiologisk",
        CCPorGAG: "CCP",
        general: "Nedkøling - bager",
        description:
          "Hvis nedkølingstiden er for lang, kan det føre til vækst af skadelige bakterier, som kan forårsage hygiejniske problemer og sygdom.",
        prevent:
          "Der skal udføres løbende visuel kontrol for at sikre, at nedkølingsprocedurerne følges. Det betyder, at temperaturen skal falde fra +65 °C til +10 °C på højst 4 timer, og fødevaren skal opbevares ved højst +5 °C derefter.",
      },
      riskAnalysis42: {
        id: "riskAnalysis42",
        risk: "Mikrobiologisk",
        CCPorGAG: "CCP",
        general: "Nedkøling",
        description:
          "Hvis varmebehandlede fødevarer ikke køles hurtigt nok, kan der opstå vækst af skadelige bakterier, især sporedannende bakterier som Clostridium perfringens, Clostridium botulinum og Bacillus cereus. Disse sporer kan overleve varmebehandling ved +75 °C og derfor stadig være til stede efter opvarmning. For at forhindre bakterievækst skal varmebehandlede fødevarer køles hurtigt ned fra 65 °C til 10 °C inden for 4 timer og derefter opbevares på køl eller frost for at sikre fødevaresikkerheden.",
        prevent:
          "Temperaturkontrol og dokumentation udføres i henhold til virksomhedens egenkontroldokument, hvor temperaturer regelmæssigt overvåges og registreres for at sikre overholdelse af fødevaresikkerhedskrav.",
      },
      riskAnalysis43: {
        id: "riskAnalysis43",
        risk: "Mikrobiologisk",
        CCPorGAG: "GAG",
        general: "Åbentbuffet",
        description:
          "For at undgå vækst af mikroorganismer, der kan forårsage sygdom, bør letfordærvelige fødevarer opbevares udenfor temperaturintervallet +5 °C til +65 °C. Sørg for, at buffeter anrettes hygiejnisk for at forhindre, at gæster smitter hinanden. Vær opmærksom på, at fødevarer som sandwich, pølsehorn eller fiskefrikadeller, der sælges udenfor køl, også kan udgøre en risiko. I køleopsatser, fx i pizzavirksomheder, bør temperaturen holdes konstant under +5 °C for at sikre fødevarernes sikkerhed.",
        prevent:
          "For opbevaring af letfordærvelige fødevarer mellem +5 °C og +65 °C, fx at mad på buffeten ikke står i længere end 3 timer, og at maden anrettes i små portioner. Der gives nye tallerkener til gæsterne, og buffeten overvåges løbende. Hvis maden håndteres uhensigtsmæssigt, fjernes den. Overskydende mad kasseres efter 3 timer eller opvarmes til +75 °C. Desinfektion eller engangshandsker anbefales for kunder.",
      },
      riskAnalysis32: {
        id: "riskAnalysis32",
        risk: "Mikrobiologisk",
        CCPorGAG: "CCP",
        general: "pH I ris",
        description:
          "Virksomheden skal dokumentere, at pH-værdien i risene ikke overstiger 4,5 efter tilsætning af sushi-zu umiddelbart efter varmebehandling. Dette gøres ved regelmæssig pH-måling med kalibreret udstyr, skriftlig procedure for tilsætning og opbevaring af måleresultater som dokumentation.",
        prevent:
          "Sørg for, at sushi-ris har en pH-værdi på maks. 4,5 efter tilsætning af sushi-zu umiddelbart efter varmebehandling, og dokumentér målingen.",
      },
      riskAnalysis44: {
        id: "riskAnalysis44",
        risk: "Mikrobiologisk",
        CCPorGAG: "CCP",
        general: "Indfrysning af fisk",
        description:
          "Rå eller letbehandlet fisk (f.eks. sushi og gravad laks) kan indeholde parasitter, som kan forårsage sygdom. For at minimere risikoen skal fisken fryses til –20 °C i 24 timer eller –18 °C i 96 timer. Alternativt kan fisken behandles med saltning, røgning eller være opdrættet under særlige forhold, der gør frysebehandling unødvendig. Dette sikrer, at fisken kan serveres sikkert.",
        prevent:
          "Temperaturkontrol og dokumentation udføres i henhold til virksomhedens egenkontroldokument, hvor temperaturer regelmæssigt overvåges og registreres for at sikre overholdelse af fødevaresikkerhedskrav.",
      },
      riskAnalysis45: {
        id: "riskAnalysis45",
        risk: "Mikrobiologisk",
        CCPorGAG: "CCP",
        general: "Kontrol af pH i syltede produkter",
        description:
          "Der er risiko for vækst af Listeria monocytogenes og Clostridium botulinum i egenproducerede syltevarer med lang holdbarhed. For at minimere denne risiko sikres det, at syltevarer med en holdbarhed over fem dage har en pH-værdi på maks. 4,4.",
        prevent:
          "Ved produktion af syltevarer med en holdbarhed på over fem dage skal det sikres, at produktets pH-værdi ikke overstiger 4,4. Dette kontrolleres løbende gennem måling og dokumentation for at forhindre vækst af Listeria monocytogenes og Clostridium botulinum.",
      },
      riskAnalysis46: {
        id: "riskAnalysis46",
        risk: "Mikrobiologisk",
        CCPorGAG: "GAG",
        general: "Bagning",
        description:
          "Ved bagning af brød skal centrumtemperaturen være høj nok til at dræbe eventuelle sygdomsfremkaldende bakterier. Hvis der er tvivl, bør temperaturen måles. Efter bagning kan brødet opbevares ved stuetemperatur, hvis det er gennembagt.",
        prevent:
          "Sørg for, at brødet når en tilstrækkelig centrumtemperatur for at dræbe bakterier. Mål temperaturen, hvis der er tvivl. Opbevar det gennembagte brød ved stuetemperatur efter bagning.",
      },
      riskAnalysis47: {
        id: "riskAnalysis47",
        risk: "Mikrobiologisk",
        CCPorGAG: "GAG",
        general: "Bageri",
        description:
          "Der fremstilles kun brød med mel, vand, salt, fedtstof/olie, krydderier og tørrede dadler. Dejen laves og køres gennem båndmaskine, og alle brødtyper afbages og pakkes samme dag. Der er opmærksomhed på allergene ingredienser, der kan afvige fra de generelle brødtyper.",
        prevent:
          "Rengøring af lokaler, anlæg og udstyr skal sikre hygiejne og forebygge kontaminering.",
      },
      riskAnalysis48: {
        id: "riskAnalysis48",
        risk: "Mikrobiologisk",
        CCPorGAG: "GAG",
        general: "Konditori",
        description:
          "Fløde og creme til flødekager skal opbevares køligt, da længere ophold ved stuetemperatur kan føre til bakterievækst og udgøre en sundhedsrisiko.",
        prevent:
          "Flødekager produceres i én sammenhængende proces uden afbrydelser. Fløde og creme tages kun ud fra køl, når kagen er klar til brug, og maksimalt 3 liter flødeskum håndteres ad gangen. Færdige flødekager opbevares straks på køl.",
      },
      riskAnalysis49: {
        id: "riskAnalysis49",
        risk: "Mikrobiologisk",
        CCPorGAG: "GAG",
        general: "Romkugler",
        description:
          "Ved fremstilling af romkugler kan bakterier og skimmel overføres fra gamle, forkert opbevarede kager eller brød med våde cremer. Der er også risiko for kontaminering fra redskaber, borde og hænder. På grund af romkuglers sammensætning udgør skimmelvækst den største risiko for sygdom.",
        prevent:
          "Romkugler fremstilles kun af brød og kager uden våde cremer. Råvarerne opbevares hygiejnisk på køl eller frost. Borde, redskaber og hænder skal være rene, og modtagne kager fra andre afdelinger skal være korrekt håndteret med procedurer dokumenteret i egenkontrolprogrammer.",
      },
      riskAnalysis50: {
        id: "riskAnalysis50",
        risk: "Mikrobiologisk",
        CCPorGAG: "GAG",
        general: "Smør og Sukker",
        description:
          "Ved fremstilling af creme og lignende produkter, der ikke varmebehandles efterfølgende, er det vigtigt at sikre god produktionshygiejne og et tilstrækkeligt højt sukkerindhold for at forhindre harskning og vækst af mikroorganismer. Opbevaringstemperatur og holdbarhed skal overholdes nøje.",
        prevent:
          "Kager med creme uden køl sikres med mindst 30 % sukkerindhold for at hæmme mikroorganismer. Holdbarhed ved stuetemperatur fastsættes af virksomheden. Creme på lager bør altid opbevares på køl.",
      },
      riskAnalysis51: {
        id: "riskAnalysis51",
        risk: "Mikrobiologisk",
        CCPorGAG: "GAG",
        general: "Frosnebær",
        description:
          "Frosne hindbær fra visse lande kan udgøre en risiko for kontaminering med norovirus (roskildesyge), som kan forårsage mave-tarm-sygdomme.",
        prevent:
          "Frosne hindbær skal varmebehandles ved 100 °C i ét minut, før de serveres eller bruges i retter uden videre varmebehandling. For sårbare grupper anbefales det, at alle frosne bær varmebehandles.",
      },
      riskAnalysis52: {
        id: "riskAnalysis52",
        risk: "Mikrobiologisk",
        CCPorGAG: "GAG",
        general: "Optøning",
        description:
          "Ved optøning vækkes eventuelle bakterier til live, hvilket kan føre til vækst. For at minimere risikoen skal optøning foregå i køleskab ved maks. 5 °C (2 °C for fisk). Produkterne skal opbevares tildækket og placeres, så de ikke drypper på andre fødevarer.",
        prevent:
          "Optø fødevarer i køleskab ved maks. 5 °C (2 °C for fisk). Opbevar tildækket og undgå, at de drypper på andre fødevarer.",
      },
      riskAnalysis53: {
        id: "riskAnalysis53",
        risk: "Mikrobiologisk",
        CCPorGAG: "GAG",
        general: "Skyl",
        description:
          "For at minimere risikoen for bakterier og virus skyller virksomheden alle frugter og grøntsager, herunder salat, spirer og krydderurter. Virksomheden følger Fødevarestyrelsens anbefaling om at give frosne bær, babymajs og sukkerærter et kort opkog før brug.",
        prevent:
          "Virksomheden følger Fødevarestyrelsens anbefaling om at give frosne bær, babymajs og sukkerærter et kort opkog før brug.",
      },
      riskAnalysis54: {
        id: "riskAnalysis54",
        risk: "Mikrobiologisk",
        CCPorGAG: "GAG",
        general: "Hakkebøffer",
        description:
          "Hvis hakket kød serveres uden at være varmebehandlet til mindst +75 °C i centrum, eller uden en alternativ behandling, der sikrer tilsvarende bakteriedrab, skal kunderne tydeligt informeres. Dette kan eksempelvis ske via menukortet, hvor det angives, at kødet er behandlet med en lempeligere metode, hvilket medfører en øget risiko for sygdomsfremkaldende bakterier.",
        prevent: "Kundeinformation.",
      },
      riskAnalysis55: {
        id: "riskAnalysis55",
        risk: "Mikrobiologisk",
        CCPorGAG: "GAG",
        general: "Æg",
        description:
          "Rå æg kan indeholde sygdomsfremkaldende mikroorganismer som salmonella. Hvis rå æg håndteres uhygiejnisk eller bruges i produkter, der ikke opvarmes til mindst +75 °C, kan det føre til sygdom. Kontaminering kan ske via udstyr, overflader, redskaber, hænder eller fødevarer, der ikke varmebehandles. Rå æg må anvendes til enkeltserveringer, som fx en rå æggeblomme på pariserbøf, men gæsterne skal tydeligt informeres, hvis rå æg anvendes",
        prevent:
          "Rå æg håndteres adskilt fra andre fødevarer, enten på et særskilt bord eller tidsadskilt på et delt bord. Overflader, redskaber og udstyr rengøres og desinficeres efter brug, og personalet vasker hænder ofte for at undgå krydskontaminering.",
      },
      riskAnalysis56: {
        id: "riskAnalysis56",
        risk: "Mikrobiologisk",
        CCPorGAG: "GAG",
        general: "Mug og Skimmel",
        description:
          "Fødevarer med mugpletter bør smides ud, da de kan indeholde svampegifte eller svampemycelium, undtagen blåskimmelost og lignende. Virksomheden sikrer korrekt opbevaring af fødevarer, f.eks. at tørvarer opbevares tørt, for at minimere risikoen for mug og skimmel.",
        prevent:
          "Opbevar fødevarer korrekt, smid mugne varer ud og undgå fugtige forhold.",
      },
      riskAnalysis57: {
        id: "riskAnalysis57",
        risk: "Mikrobiologisk",
        CCPorGAG: "CCP",
        general: "pH i syltede produkter",
        description:
          "For at forhindre vækst af Listeria monocytogenes og Clostridium botulinum i syltevarer med lang holdbarhed, bør du sikre, at pH-værdien i produktet ikke overstiger 4,4, især når holdbarheden er længere end fem dage. Dette hjælper med at bevare fødevarernes sikkerhed.",
        prevent:
          "Vær opmærksom på, at pH-værdien i syltevarer med en holdbarhed over fem dage skal være maks. 4,4 for at forhindre vækst af skadelige bakterier som Listeria og Clostridium botulinum.",
      },
      riskAnalysis58: {
        id: "riskAnalysis58",
        risk: "Mikrobiologisk",
        CCPorGAG: "GAG",
        general: "pH-måling i fermenterede grøntsager",
        description:
          "Ved fermentering er det vigtigt at følge opskriften nøje for at sikre, at de ønskede fermenteringsprocesser opnås, så det færdige produkt får de nødvendige konserverende egenskaber.",
        prevent:
          "For at sikre korrekt fermentering, følg opskriften nøje og overvåg processen for at opnå de ønskede konserverende egenskaber.",
      },
      riskAnalysis59: {
        id: "riskAnalysis59",
        risk: "Mikrobiologisk",
        CCPorGAG: "GAG/CCP",
        general: "Smoothies",
        description:
          "Frugt, grønt og bær kan indeholde bakterier og virus, der kan gøre mennesker syge. Forurening kan skyldes brug af snavset vand til vanding eller skylning, især i nogle lande, hvor vandet kan indeholde afføringssrester. Dårlig håndhygiejne under høst kan også være en kilde til smitte. Frosne hindbær, især de der importeres og bruges rå, har forårsaget sygdomsudbrud i Danmark. Hyldebær indeholder naturlige giftstoffer, der kan forårsage diarré og opkastninger kort tid efter indtagelse.",
        prevent:
          "Skyld frugt, grøntsager, salat, spirer og krydderurter grundigt og adskilt for at undgå krydsmitte. Frosne hindbær, der ikke varmebehandles, skal opvarmes i 1 minut ved 100 °C (CCP). Hyldebær skal koges i 15-20 minutter.",
      },
      riskAnalysis60: {
        id: "riskAnalysis60",
        risk: "Mikrobiologisk",
        CCPorGAG: "GAG",
        general: "Krydsforurening",
        description:
          "Fødevarer kan forurenes med bakterier gennem krydsforurening, f.eks. mellem rå og spiseklare produkter. For at undgå dette holdes råvarer og spiseklare fødevarer adskilt, og råvarer behandles separat, hvor det er relevant. Virksomheden sikrer, at knive, maskiner og skærebrætter altid er rene og rengøres grundigt efter brug.",
        prevent:
          "For at undgå krydsforurening holdes råvarer og spiseklare fødevarer adskilt. Knive, maskiner og udstyr rengøres grundigt, og arbejdstøj og klude skiftes hyppigt.",
      },
      riskAnalysis61: {
        id: "riskAnalysis61",
        risk: "Mikrobiologisk",
        CCPorGAG: "GAG",
        general: "Pålægsmaskine",
        description:
          "Ved brug af pålægsmaskiner er der risiko for krydsmitte mellem forskellige fødevarer, især hvis maskinen bruges til både ferske og tilberedte produkter. Dette kan føre til overførsel af mikroorganismer som Listeria monocytogenes, hvilket kan gøre mennesker syge, især hvis",
        prevent:
          "Pålægsmaskinen holdes løbende ren, og klingen rengøres og desinficeres regelmæssigt. Maskinen skilles ad dagligt for grundig afvaskning og desinfektion.",
      },
      riskAnalysis62: {
        id: "riskAnalysis62",
        risk: "Mikrobiologisk",
        CCPorGAG: "GAG",
        general: "Dry-aging",
        description:
          "Øksekød til steak krøgmodnes i kødmodningsskab ved højst +5°C i x uger (se procedurebeskrivelse i egenkontrolprogrammet). Under modning fordampes vand og mælkesyre, mens enzymer nedbryder bindevæv og gør kødet mørt. Hvis temperaturen overstiger +5°C, kan kødet blive klæbret og bakterievækst øges. Temperaturen skal holdes under +5°C for at forhindre mikroorganismer. Relativ luftfugtighed (70-85 %) og aw (højst 0,9) skal kontrolleres for at forhindre skimmelvækst.",
        prevent:
          "Sørg for, at temperaturen i modningsskabet ikke overstiger +5°C, og at den relative luftfugtighed er 70-85 %. Vurder kødets overflade, som skal være tør og ikke slimet. Hold modningsskabet rent, og sørg for, at produkterne hænger frit uden at berøre sider, bund eller top, så luften kan cirkulere ordentligt.",
      },
      riskAnalysis63: {
        id: "riskAnalysis63",
        risk: "Mikrobiologisk",
        CCPorGAG: "GAG",
        general: "Mejeri -Ost",
        description:
          "Utilstrækkelig produktionshygiejne ved håndtering af ost og udskæring kan føre til kontaminering, hvilket udgør en sundhedsrisiko for forbrugeren.",
        prevent:
          "Udskæring og håndtering af ost m.m. skal altid foregå på et rengjort bord med rene redskaber, og der skal være fokus på god håndhygiejne.",
      },
      riskAnalysis64: {
        id: "riskAnalysis64",
        risk: "Mikrobiologisk",
        CCPorGAG: "GAG",
        general: "Saltning",
        description:
          "Saltning hæmmer mikroorganismers vækst, men hvis ikke saltes korrekt, kan der være risiko",
        prevent:
          "Følg altid en verificeret opskrift for saltning (saltprocent, tid, temperatur). Saltningen skal foregå på køl, og saltlagen skal være frisk",
      },
      riskAnalysis65: {
        id: "riskAnalysis65",
        risk: "Mikrobiologisk",
        CCPorGAG: "GAG",
        general: "Koldrøgning af fisk",
        description:
          "Rå eller letbehandlede fisk kan indeholde parasitter eller orm, hvilket medfører risiko for sygdom hos forbrugeren.",
        prevent:
          "Fisk, der serveres rå eller let behandlet, skal fryses i mindst 24 timer ved -20 °C eller 96 timer ved -18 °C, eller behandles på anden måde for at dræbe parasitter (f.eks. saltning, røgning).",
      },
      riskAnalysis66: {
        id: "riskAnalysis66",
        risk: "Mikrobiologisk",
        CCPorGAG: "GAG",
        general: "E-coli",
        description:
          "E. coli i hakket kød indikerer fækal forurening. Grænseværdierne for bakterier må ikke overskrides. Hvis de gør, skal virksomheden forbedre hygiejnen og råvareudvælgelsen, da der kan være risiko for andre sygdomsfremkaldende bakterier.",
        prevent:
          "Virksomheden skal iværksætte handlinger som rengøring af hakkemaskinen, fokus på håndhygiejne og opfølgning på leverandørers E. coli grænseværdier. Ved overskridelse af grænseværdierne skal procedurer opdateres og indarbejdes i egenkontrolprogrammet.",
      },
      riskAnalysis67: {
        id: "riskAnalysis67",
        risk: "Mikrobiologisk",
        CCPorGAG: "GAG",
        general: "Tartar",
        description:
          "Råt oksekød kan indeholde salmonella, som kan forårsage sygdom hos mennesker.",
        prevent:
          "Brug kun hele kødstykker af god kvalitet, rengør udstyr grundigt, opbevar kød på køl ved max +5 °C, og lav tartar tæt på serveringstidspunktet. Følg hygiejnekrav for at sikre sikker servering mod salmonella.",
      },
      riskAnalysis68: {
        id: "riskAnalysis68",
        risk: "Mikrobiologisk",
        CCPorGAG: "GAG",
        general: "Hakkemaskine",
        description:
          "Hakket kød spreder overfladebakterier, og uden tilstrækkelig varmebehandling kan bakterier og parasitter overleve. Manglende rengøring af hakkemaskinen kan føre til krydskontaminering, og risikoen for bakterievækst, som Listeria, stiger. Hakning af forskellige produkter på samme maskine øger risikoen for krydskontaminering, og høj temperatur eller lang hakningstid kan fremme bakterievækst",
        prevent:
          "Hakkemaskinen skal rengøres løbende, og ved hakning af forskellige kødtyper skal der desinficeres mellem. Brug altid frisk kød, hold kødet koldt, og hak hurtigt. Hakket kød skal opbevares på køl og bruges eller fryses indenfor 24 timer.",
      },
      riskAnalysis69: {
        id: "riskAnalysis69",
        risk: "Mikrobiologisk",
        CCPorGAG: "GAG",
        general: "Parasitter",
        description:
          "For høj temperatur i for lang tid kan forringe fersk fisks spisekvalitet og fremme mikroorganismers vækst, som kan gøre mennesker syge. Rå eller letbehandlede fisk (sushi, koldrøgning) kan indeholde parasitter, hvilket udgør en sygdomsrisiko for forbrugeren.",
        prevent:
          "Fersk fisk skal opbevares ved højst +2 °C. Ved håndtering skal der foretages visuel kontrol for synlige parasitter, som fjernes eller får fisken kasseret. Fisk, der skal serveres rå eller let behandlet, skal fryses i mindst 24 timer ved -20 °C eller 96 timer ved -18 °C, eller behandles på anden måde (saltning, røgning) for at sikre drab af parasitter.",
      },
      riskAnalysis70: {
        id: "riskAnalysis70",
        risk: "Mikrobiologisk",
        CCPorGAG: "CCP",
        general: "Histamin",
        description:
          "Histamin findes naturligt i visse fisk og fiskevarer som tun, makrel og hornfisk. Forkert opbevaring, som for høj temperatur i længere tid, kan føre til bakteriedannelse af histamin, som kan forårsage forgiftning hos kunder.",
        prevent:
          "Fisk, der kan indeholde histamin, som tun og makrel, smages regelmæssigt. Hvis der opstår en svidende eller prikkende fornemmelse, skal fisken kasseres. For at undgå histamindannelse opbevares rå fisk ved højst +2 °C, og håndtering ved omgivelsestemperatur bør være kortvarig. Der skal være fokus på korrekt køling, fiskarten og risiko for kontaminering.",
      },
      riskAnalysis71: {
        id: "riskAnalysis71",
        risk: "Kemisk",
        CCPorGAG: "GAG",
        general: "Akrylamid og PAH",
        description:
          "PAH (kræftfremkaldende stoffer) kan dannes ved stegning, grillning eller røgning af fisk og kød. For at minimere dannelsen bør man undgå at brænke kødet og reducere os, fx ved at undgå fedt, der drypper på grillkulene. I røgede produkter kan PAH kontrolleres ved at vælge egnet brændsel, justere fødinholdet i fødevaren, optimere afstanden mellem brændsel og fødevare samt rengøre røgkammeret hyppigt.",
        prevent:
          "Foretag visuel kontrol af stegeprocessen, herunder stegeresultatet, for at sikre korrekt tilberedning og undgå dannelse af os.",
      },
      riskAnalysis72: {
        id: "riskAnalysis72",
        risk: "Kemisk",
        CCPorGAG: "GAG",
        general: "Akrylamiddannelse",
        description:
          "Risikoen for akrylamiddannelse kan minimeres ved at stege eller riste kulhydratholdige produkter ved lavere temperatur og undgå mørk farve. Fødevarestyrelsen anbefaler, at friteringen af pommes frites sker ved en temperatur under 175°C.",
        prevent:
          "Steg eller rist ved lavere temperatur og undgå mørk farve. Fritering bør være under 175°C.",
      },
      riskAnalysis73: {
        id: "riskAnalysis73",
        risk: "Kemisk",
        CCPorGAG: "GAG",
        general: "Allergener / Bager",
        description:
          "I traditionel bageriproduktion kan spor af allergene ingredienser forekomme i produkter, der fremstilles på samme udstyr, fx sesamfrø i produkter uden sesamfrø. Allergener kan forårsage alvorlige reaktioner hos følsomme personer.",
        prevent:
          "Hvis det ikke kan sikres, at der ikke overføres spor af allergene ingredienser til andre produkter (via adskilt produktion, rengøring eller andre foranstaltninger), skal det fremgå af mærkningen eller ved forespørgsel fra kunden/gæsten, at produktet kan indeholde spor af allergene ingredienser, fx sesamfrø.",
      },
      riskAnalysis74: {
        id: "riskAnalysis74",
        risk: "Kemisk",
        CCPorGAG: "GAG",
        general: "Tilsætningsstoffer",
        description:
          "Forkert dosering af tilsætningsstoffer, konserveringsmidler og ingredienser med begrænset anvendelse kan medføre hygiejniske problemer og potentielt sygdom hos forbrugeren. Dette gælder både overdosering og underdosering i forhold til den fastsatte opskrift.",
        prevent:
          "Ved brug af tilsætningsstoffer (E-numre) skal det sikres, at E-nummeret er godkendt til brug i den pågældende ret, jf. EU-databasen. Hvis der er grænseværdier, beregnes mængden korrekt, og anvendelsen skal dokumenteres gennem opskrifter, datablade eller i egenkontrolprogrammet",
      },
      riskAnalysis75: {
        id: "riskAnalysis75",
        risk: "Kemisk",
        CCPorGAG: "GAG",
        general: "Aromastoffer",
        description:
          "Ved brug af aromastoffer er der risiko for, at tilsætningen ikke sker i overensstemmelse med reglerne, som fastlagt i Europa-Parlamentets og Rådets forordning (EF) nr. 1334/2008.",
        prevent:
          "Ved køb af aromastoffer skal leverandørens anvisninger følges, og eventuelle grænseværdier skal overholdes. Hvis der ikke er mængdebegrænsninger, anvendes aromastoffet i henhold til god fremstillingspraksis, dvs. ikke mere end nødvendigt.",
      },
      riskAnalysis76: {
        id: "riskAnalysis76",
        risk: "Kemisk",
        CCPorGAG: "GAG",
        general: "Kumarin",
        description:
          "Kumarinindholdet i kanel varierer afhængigt af hvad for kaneltype, og for høje niveauer kan føre til leverskader. For at sikre fødevaresikkerheden er der fastsat grænseværdier for kumarin i færdigprodukter: 50 mg/kg for kanelindholdsbestemt traditionelt bagværk, 15 mg/kg for fint bagværk, 5 mg/kg for desserter og 20 mg/kg",
        prevent:
          "Leverandøren skal levere oplysninger om kumarinindholdet i den anvendte kanel. Alle opskrifter, der indeholder kanel, gennemgås for at sikre, at grænseværdierne for kumarin i EU's Aromaforordning ikke overskrides.",
      },
      riskAnalysis77: {
        id: "riskAnalysis77",
        risk: "Kemisk",
        CCPorGAG: "GAG",
        general: "Solanin",
        description:
          "Der er risiko for forhøjet indhold af solanin i grønne kartofler. Virksomheden sikrer derfor, at evt. spirede og grønne kartofler smides ud.",
        prevent: "Visuel kontrol af grønne kartofler.",
      },
      riskAnalysis78: {
        id: "riskAnalysis78",
        risk: "Kemisk",
        CCPorGAG: "GAG",
        general: "Cyanid",
        description:
          "Bitre mandler indeholder store mængder cyanid, som er giftigt. Bitre mandler kan dog anvendes i meget begrænset omfang.",
        prevent: "Begrænset/ingen brug af bitre mandler.",
      },
      riskAnalysis79: {
        id: "riskAnalysis79",
        risk: "Kemisk",
        CCPorGAG: "GAG",
        general: "Svampe",
        description:
          "Phenylhydrazin, som findes i champignon, kan være kræftfremkaldende. Fødevarestyrelsen anbefaler at koge eller stege champignon, da tilberedning nedbringer indholdet af phenylhydrazin.",
        prevent: "Der benyttes varmebehandlede champignon.",
      },
      riskAnalysis80: {
        id: "riskAnalysis80",
        risk: "Kemisk",
        CCPorGAG: "GAG",
        general: "Lektiner",
        description:
          "Tørrede bønner og hyldebær kan indeholde lektiner, som kan forårsage forgiftning, hvis de ikke behandles korrekt. Tørrede bønner skal udblødses og koges i rigeligt vand i henhold til producentens anvisninger. Hyldebær skal koges i mindst 15-20 minutter, og grønne bønner (haricot verts) skal blancheres for at reducere risikoen for lektinforgiftning.",
        prevent: "Undgå at bruge iblødsætningsvand. Sikre kogning.",
      },
      riskAnalysis81: {
        id: "riskAnalysis81",
        risk: "Kemisk",
        CCPorGAG: "GAG",
        general: "Svampegifte",
        description:
          "For at undgå risikoen for svampegifte bruges kun svampe, man helt sikkert kender, og kun anerkendte spisesvampe, da nogle svampe kan være farlige, hvis man ikke kender forskel.",
        prevent:
          "Brug kun kendte og anerkendte spisesvampe for at undgå risikoen for svamp",
      },
      riskAnalysis82: {
        id: "riskAnalysis82",
        risk: "Kemisk",
        CCPorGAG: "GAG",
        general: "Allergener",
        description:
          "Der er risiko for både tilsigtet og utilsigtet indhold af allergene ingredienser i fødevarerne, hvilket kan medføre alvorlige reaktioner hos allergikere. Virksomheden sikrer, at der gives oplysning om allergener, og at det tydeligt fremgår af mærkningen på færdigpakkede fødevarer. Når virksomheden modtager fødevarer, sikres det, at allergenerne er kendte og korrekt mærket. Krydskontaminering under produktion, salg og servering minimeres gennem tilstrækkelig adskillelse, rengøring og andre forholdsregler.",
        prevent:
          "Sørg for at adskille allergene ingredienser, rengør udstyr grundigt og tjek mærkningen på fødevarer. Vær klar til at informere kunder om allergener.",
      },
      riskAnalysis83: {
        id: "riskAnalysis83",
        risk: "Kemisk",
        CCPorGAG: "GAG",
        general: "Nødder og frø",
        description:
          "Der er høj risiko for aflatoksiner i blandt andet nødder, frø og tørrede frugter fra tropiske og subtropiske egne på grund af skimmelvækst under produktion. Mykotoksiner er giftige ved længere tids påvirkning.",
        prevent:
          "Leverandøren kan anvende og analysesresultater. Et samlet indtag over længere tid, anbefales forbrugeren at undgå.",
      },
      riskAnalysis84: {
        id: "riskAnalysis84",
        risk: "Kemisk",
        CCPorGAG: "GAG",
        general: "Squash",
        description:
          "Squash kan indeholde cucurbitaciner, som giver en bitter smag og kan forårsage sygdom. Hvis squash smager bittert, skal den smides ud, da selv små mængder kan være farlige, uanset om den er rå eller tilberedt.",
        prevent:
          "Ved smagning, kan en bitter smag konstateres - og råvaren bør kasseres.",
      },
      riskAnalysis85: {
        id: "riskAnalysis85",
        risk: "Kemisk",
        CCPorGAG: "GAG",
        general: "Jod i Salt",
        description:
          "Husholdningssalt og salt til brød og bagværk skal være jodberigtet, som krævet af Bekendtgørelsen om tilsætning af jod i salt.",
        prevent:
          "Husholdningssalt og salt til brød og bagværk skal indeholde 20 mg jod pr. kg. Virksomheden er ansvarlig for, at saltet indeholder den korrekte mængde jod, og dette skal fremgå af mærkningen.",
      },
      riskAnalysis86: {
        id: "riskAnalysis86",
        risk: "Kemisk",
        CCPorGAG: "GAG",
        general: "Fødevarekontaktmaterialer",
        description:
          "Hvis fødevarekontaktmaterialer som opbevaring, emballage, redskaber og udstyr ikke er egnede, kan der opstå risiko for, at kemiske stoffer overføres fra materialet til fødevarerne.",
        prevent:
          "Det sikres gennem specifikationer og leverandørerklæringer, at indkøbte fødevarekontaktmaterialer og udstyr er egnede til formålet.",
      },
      riskAnalysis87: {
        id: "riskAnalysis87",
        risk: "Kemisk",
        CCPorGAG: "GAG",
        general: "Nitritsalt",
        description:
          "Overdosering af nitritsalt kan gøre produktet sundhedsskadeligt pga. dannelsen af kræftfremkaldende stoffer.",
        prevent:
          "Nitrit må ikke bruges til fisk. Ved kødprodukter skal nitrit være godkendt i henhold til bekendtgørelse og anvendes i målt mængde som nitritsalt (0,5 % kalium- eller natriumnitrit).",
      },
      riskAnalysis88: {
        id: "riskAnalysis88",
        risk: "Fysisk",
        CCPorGAG: "GAG",
        general: "Produktionsudstyr",
        description:
          "Hvis produktionsudstyr, lokaler og andre faciliteter ikke er velvedligeholdte, kan der opstå risiko for, at fødevarer bliver forurenet. Dette kan blandt andet ske ved afskalning af maling, løse materialer eller andre fremmedlegemer, der utilsigtet kan ende i fødevaren. Regelmæssig vedligeholdelse og rengøring er derfor afgørende for at sikre fødevarernes kvalitet og sikkerhed.",
        prevent:
          "Det tilpassede egenkontrolprogram indeholder klare procedurer for vedligeholdelse. For planlagte vedligeholdelsesopgaver udarbejdes en specifik vedligeholdelsesplan.",
      },
    },
  },
  {
    title: "Mærkning - Allergener",
    data: {
      riskAnalysis89: {
        id: "riskAnalysis89",
        risk: "Mikrobiologisk",
        CCPorGAG: "GAG",
        general: "Holdbarhedsfrister",
        description:
          "Hvis holdbarhedsfrister overskrides, kan der være risiko for vækst af uønskede mikroorganismer.",
        prevent:
          "Holdbarhedsfrister på pakkede produkter skal overholdes for at undgå risiko for mikroorganismers vækst.",
      },
      riskAnalysis90: {
        id: "riskAnalysis90",
        risk: "Kemisk",
        CCPorGAG: "GAG",
        general: "Mærkningsoplysninger",
        description:
          "Hvis mærkningsbestemmelserne ikke overholdes, mistes sporbarheden, og forbrugeren får ikke oplysninger om ingredienser, herunder eventuelle allergener.",
        prevent:
          "Det sikres, at gældende mærkningsbestemmelser overholdes, hvor der skelnes mellem færdigpakkede og ikke færdigpakkede fødevarer samt specielle regler for særlige salgssituationer. Færdigpakkede fødevarer skal mærkes med alle obligatoriske oplysninger. For mindre produktioner, der sælges til andre detailforretninger i nabolaget, gælder undtagelse for næringsstofdeklarationen. Ved direkte salg af færdigpakkede fødevarer fra samme forretning kræves obligatoriske mærkningsoplysninger, undtagen ingrediensliste, næringsstofdeklaration og QUID. Allergener skal fremhæves, hvis ingredienslisten er påsat, og oplysninger om ingredienser og allergener skal kunne fås mundtligt eller via et skilt.",
      },
      riskAnalysis91: {
        id: "riskAnalysis91",
        risk: "Kemisk",
        CCPorGAG: "GAG",
        general: "Allergener",
        description:
          "Personer med allergi kan få alvorlige reaktioner, hvis de spiser produkter, der indeholder ingredienser, de er allergiske overfor.",
        prevent:
          "Det sikres, at leverandøren giver oplysninger om allergener, enten på mærkningen af varen eller i medfølgende handelsdokumenter.",
      },
      riskAnalysis92: {
        id: "riskAnalysis92",
        risk: "Kemisk",
        CCPorGAG: "GAG",
        general: "Allergener",
        description:
          "Allergen-følsomme personer kan få alvorlige reaktioner, hvis de indtager produkter med allergene ingredienser som gluten, skaldyr, æg, fisk, jordnødder, soja, mælk, nødder, selleri, sennep, sesamfrø, svovldioxid/sulfitter, lupin og bløddyr.",
        prevent:
          "Allergene ingredienser skal oplyses for alle fødevarer, også ikke færdigpakkede. De allergene ingredienser skal fremhæves visuelt i ingredienslisten. Ved direkte salg skal der være synlig information om, at kunder kan få allergenoplysninger mundtligt. Oplysninger kan også være på menukort eller hjemmesider. Se også kemiske risikoanalyser for allergenhåndtering i virksomheden.",
      },
    },
  },
  {
    title: "Rengøring og Hygiejene",
    data: {
      riskAnalysis93: {
        id: "riskAnalysis93",
        risk: "Mikrobiologisk",
        CCPorGAG: "GAG",
        general: "Rengøring",
        description:
          "Maskiner til softice, fadøl, slushice, kaffe og isterninger skal rengøres og desinficeres regelmæssigt for at minimere risikoen for skimmel og sygdomsfremkaldende bakterier. Følg leverandørens anvisninger for bedst muligt rengøringsresultat.",
        prevent:
          "Rengør maskiner regelmæssigt og følg leverandørens anvisninger.",
      },
      riskAnalysis94: {
        id: "riskAnalysis94",
        risk: "Mikrobiologisk",
        CCPorGAG: "GAG",
        general: "Rengøring",
        description:
          "For at undgå kontaminering med mikroorganismer er det vigtigt, at lokaler, inventar og redskaber rengøres og desinficeres grundigt. Mangelfuld rengøring kan føre til, at bakterier, som Listeria, overlever og vokser i miljøet, især i maskiner som pålægsmaskiner, der ikke er ordentligt rengjorte. Bakterier kan komme ind via råvarer og dårlig personlig hygiejne.",
        prevent:
          "Rengør maskiner regelmæssigt og følg leverandørens anvisninger.",
      },
      riskAnalysis95: {
        id: "riskAnalysis95",
        risk: "Mikrobiologisk",
        CCPorGAG: "GAG",
        general: "Opvaskemaskine (+80)",
        description:
          "Rengøring og desinfektion af produktionsudstyr og redskaber skal mindske risikoen for krydskontaminering mellem forskellige fødevaregrupper.",
        prevent:
          "Desinfektionsmidler skal være godkendte, og rester skylles væk. Surt rengøringsmiddel bruges periodisk for at fjerne kalk. Personalet følger nøje instruktionerne på datablade.",
      },
      riskAnalysis96: {
        id: "riskAnalysis96",
        risk: "Mikrobiologisk",
        CCPorGAG: "GAG",
        general: "Nustilling",
        description:
          "Nustilling af køkkenet kræver, at alle flader, der ikke går i opvaskemaskinen, vaskes med kloropløsning (1 klortablet pr. liter vand eller 2 dl flydende klorprodukt til 5 liter vand). Lad kloren virke i 5 minutter, og skyl derefter grundigt med vand. Mad, der er håndteret af en syg person og ikke er varmebehandlet, skal kasseres, inkl. krydderier og krydderurter.",
        prevent:
          "For at forebygge smitte skal køkkenet regelmæssigt rengøres grundigt, især efter sygdom. Brug kloropløsning til at desinficere overflader, og sørg for, at alle fødevarer, der er håndteret af en syg person, bliver korrekt varmebehandlet eller kasseres.",
      },
      riskAnalysis97: {
        id: "riskAnalysis97",
        risk: "Mikrobiologisk",
        CCPorGAG: "GAG",
        general: "Norovirus",
        description:
          "Norovirus forårsager maveinfektion med diarré og opkastning. Virus kan smitte via kontakt og berøring af fødevarer eller overflader. Det overlever frysning og de fleste kemikalier, men dør ved kogning eller høje koncentrationer af klor.",
        prevent:
          "Medarbejdere skal melde sygdom til køkkenchefen og være opmærksomme på Norovirus. Sørg for håndvask, opbevaring af ejendele i garderoben og arbejde med varmebehandlede fødevarer. Ved opkast eller diarré, bliv hjemme 48 timer.",
      },
      riskAnalysis98: {
        id: "riskAnalysis98",
        risk: "Mikrobiologisk",
        CCPorGAG: "GAG",
        general: "Hygiejne",
        description:
          "Utilstrækkelig personlig hygiejne kan føre til spredning af bakterier og virus i maden",
        prevent: "Oprethold god personlig hygiejne og ren arbejdsbeklædning.",
      },
      riskAnalysis99: {
        id: "riskAnalysis99",
        risk: "Kemisk",
        CCPorGAG: "GAG",
        general: "Rengøring",
        description:
          "Alle overflader, inventar og redskaber, der har været i kontakt med uemballerede fødevarer, skal desinficeres efter rengøring. Vær opmærksom på, at klorholdige og sure rengøringsmidler ikke må anvendes sammen, da de kan danne giftige dampe, der er farlige at indånde.",
        prevent:
          "Desinfektionsmidler skal være godkendte, og rester skylles væk. Surt rengøringsmiddel bruges periodisk for at fjerne kalk. Personalet følger nøje instruktionerne på datablade.",
      },
      riskAnalysis100: {
        id: "riskAnalysis100",
        risk: "Fysisk",
        CCPorGAG: "GAG",
        general: "Rengøring ",
        description:
          "Manglende vedligeholdelse af produktionsudstyr og lokaler kan føre til forurening af fødevarer med fremmedlegemer som afskalning af maling. Det kan også forhindre effektiv rengøring og desinfektion, hvilket øger risikoen for krydssmitte til fødevarer.",
        prevent:
          "I det tilpassede egenkontrolprogram er der etableret procedurer for vedligeholdelse. Ved planlagte vedligeholdelsesopgaver udarbejdes en specifik vedligeholdelsesplan.",
      },
    },
  },
  {
    title: "Håndtering af affald",
    data: {
      riskAnalysis101: {
        id: "riskAnalysis101",
        risk: "Mikrobiologisk",
        CCPorGAG: "GAG",
        general: "Affald",
        description:
          "Hvis affaldshåndteringen ikke udføres hygiejnisk, kan affald forurene lokaler, inventar og fødevarer. Dette kan føre til krydskontaminering og øge risikoen for sygdomsfremkaldende bakterier, der kan påvirke fødevaresikkerheden.",
        prevent:
          "Affald skal håndteres hygiejnisk, opsamles i passende beholdere, og fjernes dagligt. Sørg for, at containere tømmes regelmæssigt, kan lukkes, og at affald ikke henstår udenfor.",
      },
    },
  },
  {
    title: "Sporbarehd og tilbagetræning",
    data: {
      riskAnalysis102: {
        id: "riskAnalysis102",
        risk: "Mikrobiologisk",
        CCPorGAG: "GAG",
        general: "Sporbarhed",
        description:
          "Sørg for at have sporbarhed på alle varer, der modtages og leveres. Dette er afgørende for at sikre, at du kun bruger eller sælger varer, der overholder gældende regler og ikke udgør en sundhedsrisiko. Hvis du ikke kan identificere dine varer, kan du ikke træffe de nødvendige foranstaltninger, hvis der skulle opstå problemer.",
        prevent:
          "Alle varer skal have sporbarhedsdokumenter, der indeholder oplysninger om leverandør, modtager, varer, dato og mængde. For fisk og skaldyr skal der også oplyses om art, produktionsmetode, og opdrætområde. Dokumenterne skal opbevares i 6 måneder. Sporbarhedsdokumenter skal udarbejdes ved levering af fødevarer ud af huset, og opbevares i 6 måneder.",
      },
      riskAnalysis103: {
        id: "riskAnalysis103",
        risk: "Mikrobiologisk",
        CCPorGAG: "GAG",
        general: "Tilbagetrækning",
        description:
          "Det er vigtigt at have klare procedurer for tilbagetrækning af varer, hvis et sundhedsskadeligt produkt er blevet leveret. Uden disse procedurer risikerer du at servere eller sælge kontaminerede varer. Hvis du får besked om en tilbagetrækning eller en sundhedsfare, skal du hurtigt kunne reagere og sikre, at berørte varer fjernes fra salg.",
        prevent:
          "Hvis en vare skal tilbagetrækkes, skal du kunne identificere og fjerne varen fra produktionen og returnere den til leverandøren eller kassere den. Ved tilbagetrækning skal kunder kontaktes direkte, og for storkunder skal der iværksættes en tilbagekaldelse, eventuelt via Fødevarestyrelsen. Hvis varerne er blevet håndteret i køkkenet, skal der laves ekstra rengøring.",
      },
      riskAnalysis104: {
        id: "riskAnalysis104",
        risk: "Kemisk",
        CCPorGAG: "GAG",
        general: "Identificering af varer",
        description:
          "Det er vigtigt at kunne identificere alle varer ved modtagelse for at sikre, at de overholder gældende regler og ikke udgør sundhedsrisiko. Ved levering af fødevarer ud af huset skal du have styr på, hvem der modtager varerne, så du kan tilbagekalde dem, hvis de viser sig at være sundhedsskadelige.",
        prevent:
          "Alle varer skal have sporbarhedsdokumenter, som indeholder oplysninger om leverandør, modtager, varer, dato og mængde. For fisk og skaldyr kræves ekstra oplysninger om art, produktionsmetode og opdrætområde. Sporbarhedsdokumenterne skal opbevares i 6 måneder og udarbejdes også ved levering af fødevarer ud af huset.",
      },
      riskAnalysis105: {
        id: "riskAnalysis105",
        risk: "Kemisk",
        CCPorGAG: "GAG",
        general: "Tilbagetrækning",
        description:
          "Hvis en vare skal tilbagetrækkes, skal du have klare procedurer for at sikre, at tilbagetrukne varer ikke serveres eller sælges. Hvis varerne er blevet håndteret i køkkenet, kan dine produkter blive kontamineret, og du skal iværksætte ekstra rengøring. Uden korrekte procedurer risikerer du at gøre mennesker syge ved at servere sundhedsskadelige fødevarer.",
        prevent:
          "Ved tilbagetrækning af varer skal du hurtigt kunne identificere og fjerne de berørte varer fra produktionen. Hvis varerne er blevet leveret ud af huset, skal du kontakte kunderne direkte. Ved storkunder skal Fødevarestyrelsen kontaktes, og en tilbagekaldelse iværksættes. Hvis varerne er håndteret i køkkenet, skal ekstra rengøring og desinfektion gennemføres. Dokumentation af tilbagetrækning og rengøring er vigtig og skal gemmes.",
      },
      riskAnalysis106: {
        id: "riskAnalysis106",
        risk: "Fysisk",
        CCPorGAG: "GAG",
        general: "Identificering af varer",
        description:
          "Det er vigtigt at kunne identificere alle varer ved modtagelse for at sikre, at de overholder gældende regler og ikke udgør sundhedsrisiko. Ved levering af fødevarer ud af huset skal du have styr på, hvem der modtager varerne, så du kan tilbagekalde dem, hvis de viser sig at være sundhedsskadelige.",
        prevent:
          "Alle varer skal have sporbarhedsdokumenter, som indeholder oplysninger om leverandør, modtager, varer, dato og mængde. For fisk og skaldyr kræves ekstra oplysninger om art, produktionsmetode og opdrætområde. Sporbarhedsdokumenterne skal opbevares i 6 måneder og udarbejdes også ved levering af fødevarer ud af huset.",
      },
      riskAnalysis107: {
        id: "riskAnalysis107",
        risk: "Fysisk",
        CCPorGAG: "GAG",
        general: "Tilbagetrækning",
        description:
          "Hvis en vare skal tilbagetrækkes, skal du have klare procedurer for at sikre, at tilbagetrukne varer ikke serveres eller sælges. Hvis varerne er blevet håndteret i køkkenet, kan dine produkter blive kontamineret, og du skal iværksætte ekstra rengøring. Uden korrekte procedurer risikerer du at gøre mennesker syge ved at servere sundhedsskadelige fødevarer.",
        prevent:
          "Ved tilbagetrækning af varer skal du hurtigt kunne identificere og fjerne de berørte varer fra produktionen. Hvis varerne er blevet leveret ud af huset, skal du kontakte kunderne direkte. Ved storkunder skal Fødevarestyrelsen kontaktes, og en tilbagekaldelse iværksættes. Hvis varerne er håndteret i køkkenet, skal ekstra rengøring og desinfektion gennemføres. Dokumentation af tilbagetrækning og rengøring er vigtig og skal gemmes.",
      },
    },
  },
  {
    title: "Vedligeholdelse og skadedyrssikring",
    data: {
      riskAnalysis108: {
        id: "riskAnalysis108",
        risk: "Mikrobiologisk",
        CCPorGAG: "GAG",
        general: "Vedligeholdelse",
        description:
          "Utilstrækkelig vedligeholdelse af produktionsudstyr og lokaler kan føre til, at fødevarer forurenes med fremmedlegemer som malingsafskalning. Det kan også forhindre effektiv rengøring og desinfektion, hvilket øger risikoen for krydsmitte mellem fødevarer.",
        prevent:
          "I det tilpassede egenkontrolprogFor at sikre korrekt vedligeholdelse bør der følge faste procedurer. Ved planlagte vedligeholdelsesopgaver anbefales det at udarbejde en detaljeret vedligeholdelsesplan.am er der fastlagt procedurer for vedligeholdelse. For planlagte vedligeholdelsesopgaver udarbejdes en specifik vedligeholdelsesplan.",
      },
      riskAnalysis109: {
        id: "riskAnalysis109",
        risk: "Mikrobiologisk",
        CCPorGAG: "GAG",
        general: "Skadedyrssikring",
        description:
          "Skadedyrs tilstedeværelse i køkken og lokaler kan medføre forurening af fødevarer og inventar via ekskrementer, kloakmateriale og direkte smitte fra skadedyrene.",
        prevent:
          "Alle lokaler skal sikres mod skadedyr med tætsluttende døre, fluenet og fastspændte afløbsriste. Ved opdagelse af skadedyr, skal der iværksættes bekæmpelse og grundig rengøring af berørte områder. Ved rotter eller mus stoppes produktionen, og fødevarer kasseres. Kommunen og fødevaremyndigheder skal kontaktes straks.",
      },
      riskAnalysis110: {
        id: "riskAnalysis110",
        risk: "Kemisk",
        CCPorGAG: "GAG",
        general: "Skadedyrssikring",
        description:
          "Anvendelse af kemikalier til skadedyrbekæmpelse kan medføre risiko for forurening af fødevarer, hvilket kan føre til, at reststoffer fra sprøjtegifte eller mussekorn gør mennesker syge.",
        prevent:
          "For at sikre fødevaresikkerhed skal gift til skadedyrbekæmpelse anvendes i henhold til gældende lovgivning. Der må ikke udlægges gift i lokaler, hvor mad opbevares eller produceres. Ved skadedyrbekæmpelse anbefales det at kontakte et autoriseret bekæmpelsesfirma, og bekæmpelse af rotter eller mus skal altid udføres af et autoriseret firma.",
      },
      riskAnalysis111: {
        id: "riskAnalysis111",
        risk: "Fysisk",
        CCPorGAG: "GAG",
        general: "Produktionudstyr",
        description:
          "Manglende vedligeholdelse af produktionsudstyr og lokaler kan føre til, at fødevarer forurenes med fremmedlegemer som afskalning af maling. Det kan også forhindre korrekt rengøring og desinfektion, hvilket øger risikoen for kryssmitte til fødevarerne.",
        prevent:
          "I det tilpassede egenkontrolprogram er der etableret procedurer for vedligeholdelse. Ved planlagte vedligeholdelsesopgaver udarbejdes en specifik vedligeholdelsesplan.",
      },
    },
  },
];
